import React, { useEffect, useState } from "react"
import Image from "components/image"
import { Link } from "gatsby"

const Info = () => {
  const [slideElements, setSlideElements] = useState(false)
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setSlideElements(true)
          }
        })
      },
      {
        root: null,
        threshold: 0.5,
      }
    )

    observer.observe(document.querySelector("#values"))
  })
  return (
    <section className="mx-auto mb-16 md:mb-24" id="values">
      <div className="lg:flex items-center">
        <div className="w-full lg:w-1/2 xl:w-3/5">
          <Image source="info" />
        </div>
        <div className="w-full mt-8 lg:mt-0 lg:w-1/2 xl:w-2/5">
          <div className="w-10/12 mx-auto md:pl-6">
            <div className={slideElements ? "fadeInUp" : "opacity-0"}>
              <h4 className="text-grey-100 font-semibold text-2xl">
                Efficient Banking Engine
              </h4>
              <p
                className="text-base text-grey-200 mt-3"
                style={{ lineHeight: "28px" }}
              >
                Our banking engine provides you with all the management,
                monitoring, transaction control and reporting to efficiently
                manage your back office operations
              </p>
            </div>
            <div
              className={`mt-8 delay-500ms opacity-0 ${slideElements ? "fadeInUp" : ""}`}
            >
              <h4 className="text-grey-100 font-semibold text-2xl">
                Suite of Microservices
              </h4>
              <p
                className="text-base text-grey-200 mt-3"
                style={{ lineHeight: "28px" }}
              >
                We have a range of microservices and we are consistently adding
                to our suite just so we can serve you better and you can get all
                you need in from one place.
              </p>
            </div>
            <div
              className={`mt-8 delay-700ms opacity-0 ${slideElements ? "fadeInUp" : ""}`}
            >
              <h4 className="text-grey-100 font-semibold text-2xl">
                Process Management
              </h4>
              <p
                className="text-base text-grey-200 mt-3"
                style={{ lineHeight: "28px" }}
              >
                WoodCore fully automates your banking process, thus minimizing
                risk of manual errors and saves times too!
              </p>
            </div>

            <div
              className={`mt-12 delay-1s opacity-0 ${slideElements ? "fadeInUp" : ""}`}
            >
              <Link to="/solutions">
                <div className="flex items-center">
                  <p className="text-green font-medium text-base mr-2 hover:text-green-dark duration-500">
                    Click to read more
                  </p>
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="slide"
                  >
                    <path
                      d="M0 13.3907L5.60816 7.77028L0 2.14987L1.72653 0.42334L9.07347 7.77028L1.72653 15.1172L0 13.3907Z"
                      fill="#52BD95"
                    />
                    <path
                      d="M7.84888 13.6968L13.457 8.07643L7.84888 2.45602L9.57541 0.729492L16.9223 8.07643L9.57541 15.4234L7.84888 13.6968Z"
                      fill="#52BD95"
                    />
                  </svg>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Info
